import type { MenuProps, MenuTriggerProps } from 'react-aria-components';
import { MenuTrigger, Button, Popover, Menu } from 'react-aria-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';



interface MenuButtonProps<T> extends MenuProps<T>, Omit<MenuTriggerProps, 'children'> {
	icon: IconDefinition;
	className?: string;
}


export const MenuButton = <T extends object>(props: MenuButtonProps<T>) => {
	const { icon, children, className, ...otherProps } = props;

	return (
		<MenuTrigger {...otherProps}>

			<Button className={`react-aria-menu-button${className ? ` ${className}` : ''}`} autoFocus={false}>
				<FontAwesomeIcon icon={icon} />
			</Button>

			<Popover>
				<Menu {...otherProps}>
					{children}
				</Menu>
			</Popover>
		</MenuTrigger>
	)
}